/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import apiClient from '../api/client';
import { getAgenticAiServiceError } from '../utils/agenticAiErrors';

export const knowledgeBaseService = {
  // GET /api/knowledge-bases?accountId=
  getKnowledgeBases: (params = {}) => apiClient.get('/knowledge-bases', { params }),

  // POST /api/knowledge-bases
  createKnowledgeBase: (payload) => apiClient.post('/knowledge-bases', payload),

  // DELETE /api/knowledge-bases/:id?accountId=
  deleteKnowledgeBase: (id, params = {}) =>
    apiClient.delete(`/knowledge-bases/${encodeURIComponent(id)}`, { params }),

  // GET /api/knowledge-bases/:id/documents?accountId=
  getDocuments: (id, params = {}) =>
    apiClient.get(`/knowledge-bases/${encodeURIComponent(id)}/documents`, { params }),

  // DELETE /api/knowledge-bases/:id/documents/:documentId?accountId=
  deleteDocument: (id, documentId, params = {}) =>
    apiClient.delete(
      `/knowledge-bases/${encodeURIComponent(id)}/documents/${encodeURIComponent(documentId)}`,
      { params }
    ),

  // POST /api/knowledge-bases/:id/documents (multipart: file, accountId?, serviceRequestTypeUid?, hierarchyNodeUid?, metadata?)
  uploadDocument: (id, formData, { onUploadProgress } = {}) =>
    apiClient.post(`/knowledge-bases/${encodeURIComponent(id)}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    }),
};

// Document upload limits (mirror server/src/knowledge-bases/knowledge-bases.constants.ts)
export const KB_DOCUMENT_MAX_SIZE_BYTES = 50 * 1024 * 1024;
export const KB_METADATA_MAX_PAIRS = 25;
export const KB_METADATA_KEY_MAX_LENGTH = 100;
export const KB_METADATA_VALUE_MAX_LENGTH = 500;

// Error codes returned when the account's AI Agent integration is not usable
export const AI_AGENT_ERROR_CODES = ['AI_AGENT_NOT_ENABLED', 'AI_AGENT_TENANT_NOT_CONFIGURED'];

// When the Agentic AI platform itself is not responding, a friendly message wins
// over the raw server text (used by every Knowledge Base / AI Agent toast).
export const getApiErrorMessage = (err, fallback) => {
  const serviceError = getAgenticAiServiceError(err);
  if (serviceError) { return serviceError.toast; }
  const msg = err?.response?.data?.message;
  return Array.isArray(msg) ? msg[0] : (msg || fallback);
};
